<!-- Welcome -->
<div class="welcome-card">
    <div>
        <h2 style="font-weight: normal;">Welcome Back, <span style="font-weight: 600;">{{user.name}}</span>
            ({{user.position}})</h2>
        <p>Manage your classes, students, attendance and assignments efficiently.</p>
    </div>

    <button class="btn btn-primary">
        <i class="bi bi-plus-circle"></i>
        Create Assignment
    </button>
</div>

<!-- Page header -->
<!-- <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
    <div>&nbsp;</div>
    <button class="btn btn-light border date-btn mt-2 mt-md-0">
        <i class="bi bi-calendar3 me-2"></i>May 15, 2025 <i class="bi bi-chevron-down ms-2 small"></i>
    </button>
</div> -->

<!-- Stat cards -->
<div class="row g-3 mt-0 mb-4">
    <div class="col-6 col-xl-3">
        <div class="card stat-card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="stat-data">
                    <div class="stat-icon bg-primary-subtle text-primary"><i class="bi bi-bus-front-fill"></i></div>
                    <div class="ms-3 flex-grow-1">
                        <div class="small text-muted">Active Buses</div>
                        <h3 class="mb-0 fw-bold">42<span class="text-muted fw-normal fs-5">/48</span></h3>
                        <small class="text-muted">87.5% in operation</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-xl-3">
        <div class="card stat-card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="stat-data">
                    <div class="stat-icon bg-success-subtle text-success"><i class="bi bi-signpost-split-fill"></i>
                    </div>
                    <div class="ms-3 flex-grow-1">
                        <div class="small text-muted">Routes Running</div>
                        <h3 class="mb-0 fw-bold">28</h3>
                        <small class="text-muted">of 35 total routes</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-xl-3">
        <div class="card stat-card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="stat-data">
                    <div class="stat-icon bg-warning-subtle text-warning"><i class="bi bi-people-fill"></i></div>
                    <div class="ms-3 flex-grow-1">
                        <div class="small text-muted">Students Onboard</div>
                        <h3 class="mb-0 fw-bold">1,284</h3>
                        <small class="text-muted">On 28 routes</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-6 col-xl-3">
        <div class="card stat-card border-0 shadow-sm h-100">
            <div class="card-body">
                <div class="stat-data">
                    <div class="stat-icon bg-danger-subtle text-danger"><i class="bi bi-exclamation-triangle-fill"></i>
                    </div>
                    <div class="ms-3 flex-grow-1">
                        <div class="small text-muted">Fuel Usage</div>
                        <h3 class="mb-0 fw-bold">1,280 L</h3>
                        <small class="text-muted">Daily Consumption</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Middle row -->
<div class="row g-3 mb-4">
    <!-- Live Fleet Tracking -->
    <div class="col-lg-7 col-xl-8">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center border-0 pt-3">
                <h6 class="mb-0 fw-semibold"><i class="bi bi-geo-alt-fill text-primary me-2"></i>Live Fleet Tracking
                </h6>
                <span class="small text-success"><span class="status-dot"></span> Live</span>
            </div>
            <div class="card-body pt-2">
                <div class="map-wrap">
                    <!-- Stylised map -->
                    <svg viewBox="0 0 600 340" preserveAspectRatio="none" class="map-svg">
                        <rect width="600" height="340" fill="#eef3f6" />
                        <!-- river -->
                        <path d="M420,0 C440,80 380,160 460,240 C500,290 470,340 500,340 L600,340 L600,0 Z"
                            fill="#bfdcec" opacity=".6" />
                        <!-- parks -->
                        <rect x="30" y="40" width="90" height="70" rx="8" fill="#d8ebd0" />
                        <rect x="180" y="220" width="120" height="80" rx="8" fill="#d8ebd0" />
                        <!-- roads -->
                        <path d="M0,90 L600,150" stroke="#fff" stroke-width="6" />
                        <path d="M0,230 L600,200" stroke="#fff" stroke-width="6" />
                        <path d="M150,0 L200,340" stroke="#fff" stroke-width="6" />
                        <path d="M380,0 L350,340" stroke="#fff" stroke-width="6" />
                        <!-- routes -->
                        <path d="M80,70 C150,120 200,180 280,160" stroke="#3b82f6" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <path d="M280,80 C320,140 360,180 460,180" stroke="#10b981" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <path d="M500,140 C480,200 460,250 420,290" stroke="#f59e0b" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <path d="M120,260 C200,240 240,210 320,260" stroke="#8b5cf6" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <path d="M360,290 C320,260 280,230 260,200" stroke="#ef4444" stroke-width="3" fill="none"
                            stroke-linecap="round" />
                        <!-- labels -->
                        <text x="40" y="30" font-size="11" fill="#64748b">Green Park</text>
                        <text x="240" y="200" font-size="11" fill="#64748b">City Center</text>
                        <text x="60" y="280" font-size="11" fill="#64748b">Lake View</text>
                        <text x="470" y="30" font-size="11" fill="#64748b">Sunrise</text>
                        <text x="380" y="310" font-size="11" fill="#64748b">New Town</text>
                    </svg>
                    <!-- bus pins -->
                    <span class="pin" style="top:14%; left:12%; background:#3b82f6"><i
                            class="bi bi-bus-front-fill"></i></span>
                    <span class="pin" style="top:18%; left:46%; background:#10b981"><i
                            class="bi bi-bus-front-fill"></i></span>
                    <span class="pin" style="top:38%; left:80%; background:#f59e0b"><i
                            class="bi bi-bus-front-fill"></i></span>
                    <span class="pin" style="top:70%; left:18%; background:#8b5cf6"><i
                            class="bi bi-bus-front-fill"></i></span>
                    <span class="pin" style="top:78%; left:60%; background:#ef4444"><i
                            class="bi bi-bus-front-fill"></i></span>
                    <!-- map controls -->
                    <div class="map-controls">
                        <button class="btn btn-light btn-sm"><i class="bi bi-plus-lg"></i></button>
                        <button class="btn btn-light btn-sm"><i class="bi bi-dash-lg"></i></button>
                        <button class="btn btn-light btn-sm"><i class="bi bi-crosshair"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Today's Trips -->
    <div class="col-lg-5 col-xl-4">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center border-0 pt-3">
                <h6 class="mb-0 fw-semibold">Today's Trips</h6>
                <a href="#" class="small text-primary text-decoration-none">View All</a>
            </div>
            <ul class="list-group list-group-flush trip-list">
                <li class="list-group-item d-flex align-items-center">
                    <span class="route-tag bg-primary">R-01</span>
                    <div class="flex-grow-1 ms-3">
                        <div class="fw-semibold small">Green Park → Main Campus</div>
                        <small class="text-muted">07:15 AM – 08:00 AM</small>
                    </div>
                    <span class="badge status-badge bg-success-subtle text-success">Completed</span>
                </li>
                <li class="list-group-item d-flex align-items-center">
                    <span class="route-tag bg-success">R-07</span>
                    <div class="flex-grow-1 ms-3">
                        <div class="fw-semibold small">Shastri Nagar → Main Campus</div>
                        <small class="text-muted">07:20 AM – 08:05 AM</small>
                    </div>
                    <span class="badge status-badge bg-warning-subtle text-warning">Delayed</span>
                </li>
                <li class="list-group-item d-flex align-items-center">
                    <span class="route-tag bg-warning">R-12</span>
                    <div class="flex-grow-1 ms-3">
                        <div class="fw-semibold small">New Town → Main Campus</div>
                        <small class="text-muted">07:30 AM – 08:15 AM</small>
                    </div>
                    <span class="badge status-badge bg-primary-subtle text-primary">In Transit</span>
                </li>
                <li class="list-group-item d-flex align-items-center">
                    <span class="route-tag" style="background:#8b5cf6">R-03</span>
                    <div class="flex-grow-1 ms-3">
                        <div class="fw-semibold small">Lake View → Main Campus</div>
                        <small class="text-muted">07:45 AM – 08:30 AM</small>
                    </div>
                    <span class="badge status-badge bg-success-subtle text-success">Completed</span>
                </li>
            </ul>
        </div>
    </div>
</div>

<!-- Bottom row -->
<div class="row g-3 mb-4">
    <!-- Recent Alerts -->
    <div class="col-lg-12 col-xl-4">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center border-0 pt-3">
                <h6 class="mb-0 fw-semibold">Recent Alerts</h6>
                <a href="#" class="small text-primary text-decoration-none">View All</a>
            </div>
            <ul class="list-group list-group-flush alert-list">
                <li class="list-group-item d-flex"><i class="bi bi-exclamation-triangle-fill text-danger me-2 mt-1"></i>
                    <div class="flex-grow-1">
                        <div class="small">Bus BUS-102 delayed by 18 mins on R-07</div>
                    </div><small class="text-muted">8:35</small>
                </li>
                <li class="list-group-item d-flex"><i class="bi bi-fuel-pump-fill text-warning me-2 mt-1"></i>
                    <div class="flex-grow-1">
                        <div class="small">Low fuel: BUS-105 (33%)</div>
                    </div><small class="text-muted">8:20</small>
                </li>
                <li class="list-group-item d-flex"><i class="bi bi-exclamation-octagon-fill text-danger me-2 mt-1"></i>
                    <div class="flex-grow-1">
                        <div class="small">Overspeed alert: BUS-103 on R-12</div>
                    </div><small class="text-muted">8:05</small>
                </li>
                <li class="list-group-item d-flex"><i class="bi bi-wrench-adjustable text-secondary me-2 mt-1"></i>
                    <div class="flex-grow-1">
                        <div class="small">Maintenance due: BUS-104</div>
                    </div><small class="text-muted">7:50</small>
                </li>
                <li class="list-group-item d-flex"><i class="bi bi-info-circle-fill text-info me-2 mt-1"></i>
                    <div class="flex-grow-1">
                        <div class="small">Route R-15 trip started late</div>
                    </div><small class="text-muted">7:45</small>
                </li>
            </ul>
        </div>
    </div>

    <!-- Vehicle Status table -->
    <div class="col-lg-12 col-xl-8">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white d-flex justify-content-between align-items-center border-0 pt-3">
                <h6 class="mb-0 fw-semibold">Vehicle Status</h6>
                <a href="#" class="small text-primary text-decoration-none">View All Vehicles</a>
            </div>
            <div class="table-responsive">
                <table class="table align-middle mb-2 vehicle-table">
                    <thead>
                        <tr class="text-muted small">
                            <th>Bus#</th>
                            <th>Driver</th>
                            <th>Route</th>
                            <th>Fuel</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><i class="bi bi-bus-front-fill text-primary me-2"></i><strong>BUS-101</strong></td>
                            <td><img src="https://i.pravatar.cc/24?img=15" class="rounded-circle me-2" width="24"
                                    height="24">Ramesh Singh</td>
                            <td><span class="route-tag sm bg-primary">R-01</span></td>
                            <td>
                                <div class="d-flex align-items-center"><span class="me-2 small">78%</span>
                                    <div class="progress flex-grow-1" style="height:6px">
                                        <div class="progress-bar bg-primary" style="width:78%"></div>
                                    </div>
                                </div>
                            </td>
                            <td><span class="badge status-badge bg-success-subtle text-success">On Route</span></td>
                            <td><i class="bi bi-three-dots-vertical text-muted"></i></td>
                        </tr>
                        <tr>
                            <td><i class="bi bi-bus-front-fill text-success me-2"></i><strong>BUS-102</strong></td>
                            <td><img src="https://i.pravatar.cc/24?img=22" class="rounded-circle me-2" width="24"
                                    height="24">Suresh Yadav</td>
                            <td><span class="route-tag sm bg-success">R-07</span></td>
                            <td>
                                <div class="d-flex align-items-center"><span class="me-2 small">46%</span>
                                    <div class="progress flex-grow-1" style="height:6px">
                                        <div class="progress-bar bg-success" style="width:46%"></div>
                                    </div>
                                </div>
                            </td>
                            <td><span class="badge status-badge bg-warning-subtle text-warning">Delayed</span></td>
                            <td><i class="bi bi-three-dots-vertical text-muted"></i></td>
                        </tr>
                        <tr>
                            <td><i class="bi bi-bus-front-fill text-warning me-2"></i><strong>BUS-103</strong></td>
                            <td><img src="https://i.pravatar.cc/24?img=33" class="rounded-circle me-2" width="24"
                                    height="24">Vikram Patel</td>
                            <td><span class="route-tag sm bg-warning">R-12</span></td>
                            <td>
                                <div class="d-flex align-items-center"><span class="me-2 small">62%</span>
                                    <div class="progress flex-grow-1" style="height:6px">
                                        <div class="progress-bar bg-warning" style="width:62%"></div>
                                    </div>
                                </div>
                            </td>
                            <td><span class="badge status-badge bg-primary-subtle text-primary">In Transit</span></td>
                            <td><i class="bi bi-three-dots-vertical text-muted"></i></td>
                        </tr>
                        <tr>
                            <td><i class="bi bi-bus-front-fill" style="color:#8b5cf6"></i> <strong>BUS-104</strong></td>
                            <td><img src="https://i.pravatar.cc/24?img=51" class="rounded-circle me-2" width="24"
                                    height="24">Mahesh Kumar</td>
                            <td><span class="route-tag sm" style="background:#8b5cf6">R-03</span></td>
                            <td>
                                <div class="d-flex align-items-center"><span class="me-2 small">85%</span>
                                    <div class="progress flex-grow-1" style="height:6px">
                                        <div class="progress-bar" style="width:85%;background:#8b5cf6"></div>
                                    </div>
                                </div>
                            </td>
                            <td><span class="badge status-badge bg-success-subtle text-success">On Route</span></td>
                            <td><i class="bi bi-three-dots-vertical text-muted"></i></td>
                        </tr>
                        <tr>
                            <td><i class="bi bi-bus-front-fill text-danger me-2"></i><strong>BUS-105</strong></td>
                            <td><img src="https://i.pravatar.cc/24?img=60" class="rounded-circle me-2" width="24"
                                    height="24">Ajay Verma</td>
                            <td><span class="route-tag sm bg-danger">R-15</span></td>
                            <td>
                                <div class="d-flex align-items-center"><span class="me-2 small">33%</span>
                                    <div class="progress flex-grow-1" style="height:6px">
                                        <div class="progress-bar bg-danger" style="width:33%"></div>
                                    </div>
                                </div>
                            </td>
                            <td><span class="badge status-badge bg-secondary-subtle text-secondary">Scheduled</span>
                            </td>
                            <td><i class="bi bi-three-dots-vertical text-muted"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

    <!-- Quick Actions -->
    <div class="col-lg-12 col-xl-12">
        <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-white border-0 pt-3">
                <h6 class="mb-0 fw-semibold">Quick Actions</h6>
            </div>
            <div class="card-body">
                <div class="row g-2">
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-bus-front-fill text-primary fs-4 d-block mb-1"></i><span class="small">Add
                                Vehicle</span></button></div>
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-signpost-2-fill text-success fs-4 d-block mb-1"></i><span class="small">Add
                                Route</span></button></div>
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-person-fill text-info fs-4 d-block mb-1"></i><span class="small">Add
                                Driver</span></button></div>
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-fuel-pump-fill text-warning fs-4 d-block mb-1"></i><span class="small">Log
                                Fuel</span></button></div>
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-fuel-pump-fill text-warning fs-4 d-block mb-1"></i><span class="small">Log
                                Fuel</span></button></div>
                    <div class="col-4 col-xl-2"><button class="btn quick-btn w-100"><i
                                class="bi bi-signpost-2-fill text-success fs-4 d-block mb-1"></i><span class="small">Add
                                Route</span></button></div>
                </div>
            </div>
        </div>
    </div>
